__turbopack_context__.v({
  "yes_or_no_buttons": "apply-for-this-job-modal-module__kMd0Mq__yes_or_no_buttons",
});
